import { departmentsService } from "@/apis/services"
import { IDepartment, IPaginationMeta, IPaginationParamV2 } from "@/types"
import { create } from "zustand"
import { devtools } from "zustand/middleware"

interface IDepartmentState {
  departments: IDepartment[]
  currentDepartment: IDepartment | null
  meta?: IPaginationMeta
  isLoading: boolean
  error: string | null
  fetchDepartments: (params: IPaginationParamV2) => Promise<void>
}

const initialState = {
  departments: [],
  currentDepartment: null,
  meta: undefined,
  isLoading: false,
  error: null,
}

export const useDepartmentsStore = create<IDepartmentState>()(
  devtools(set => ({
    ...initialState,

    fetchDepartments: async (params: IPaginationParamV2) => {
      set({ isLoading: true, error: null })
      try {
        const response = await departmentsService.getDepartmentsService(params)
        set({ departments: response.data.items, meta: response.data.meta })
      } catch (error) {
        const errorMessage: string = error instanceof Error ? error.message : "An unknown error occured"
        set({ error: errorMessage })
        throw error
      } finally {
        set({ isLoading: false })
      }
    },
  }))
)
